import {
  Home, Layers, Building2, Hammer, Ruler, Bath, Warehouse,
  Wrench, Lightbulb, ShieldCheck,
} from "lucide-react";

// Maps backend icon-name strings to lucide-react components
export const ICONS = {
  Home, Layers, Building2, Hammer, Ruler, Bath, Warehouse,
  Wrench, Lightbulb, ShieldCheck,
};

export const getIcon = (name) => ICONS[name] || Wrench;
